import { render, staticRenderFns } from "./Campbell-data.vue?vue&type=template&id=80fa6cda"
import script from "./Campbell-data.vue?vue&type=script&lang=js"
export * from "./Campbell-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports